module.exports = __webpack_public_path__ + "static/media/sito_blue.d065d056.png";